import { Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const AttachmentRecord = Record(
  {
    id: null,
    label: null,
    path: null
  },
  "AttachmentRecord"
);

const data = {};

createFromJS.registerCallback("AttachmentRecord", createFromJS.createNestedCallback(AttachmentRecord, data));
